import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const generic = ['Te dice que gastes menos, sin mirar tus números', 'Reparte tus ingresos con porcentajes fijos iguales para todos', 'Ignora las diferencias entre hogares, sueldos, deudas y responsabilidades', 'Deja el "cómo" para que lo resuelvas solo'];
const system = ['Parte del diagnóstico de tu situación actual', 'Adapta los cuatro bolsillos a tus ingresos y prioridades reales', 'Desarrolla una etapa por tomo, en orden, sin saltos', 'Cierra cada etapa con ejercicios y acciones concretas'];
export function Difference() {
  return <section className="w-full bg-white" data-id="element-69" data-mp="3dgxpxnv478wv">
      <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-70" data-mp="3di8sjkctqame">
        <div className="max-w-3xl" data-id="element-71" data-mp="3iez9sb0d7c9e">
          <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-72" data-mp="3ig0u7639tb3s">
            ¿Qué lo hace diferente?
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-73" data-mp="1goxjkgtdrwj8">
            La intención no es que acumules información, sino que puedas usarla
            para construir un sistema personal que se sostenga en el tiempo.
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-74" data-mp="1f9bqqe9v0tj6">
          <div className="flex h-full flex-col rounded-2xl border border-line bg-cream p-7" data-id="element-75" data-mp="1t18ek64hwh9r">
            <h3 className="font-display text-lg font-extrabold text-ink" data-id="element-76" data-mp="1o1lzdr53wqyb">
              El consejo financiero de siempre
            </h3>
            <ul className="mt-5 space-y-3.5" data-id="element-77" data-mp="10ckzisacao4n">
              {generic.map(item => <li key={item} className="flex items-start gap-3 text-base text-ink-muted" data-id="element-78" data-mp="wbrb7xszj7b8">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-79" data-mp="1aaqyb10une5a" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex h-full flex-col rounded-2xl bg-forest p-7" data-id="element-80" data-mp="2lpnoie8rs9e8">
            <h3 className="font-display text-lg font-extrabold text-cream" data-id="element-81" data-mp="2lrqrdyv0tx0d">
              El Método de los 4 Bolsillos
            </h3>
            <ul className="mt-5 space-y-3.5" data-id="element-82" data-mp="2orip3jnar8oy">
              {system.map(item => <li key={item} className="flex items-start gap-3 text-base text-cream/85" data-id="element-83" data-mp="2otbocdvkyqmx">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-84" data-mp="2sux9emi9qb87" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}